<template>
  <div>
    <v-form v-model="isFormValid">
      <v-container class="mt-3" v-if="this.claimFields && !this.zeroSales && this.loading == false">
        <v-row justify="end">
          <v-btn class="mr-2" fab small @click="onSubmit" v-if="isEditing" :disabled="!isFormValid">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
          <v-btn class="mr-2" fab small @click="onEdit" v-if="!claim.approved">
            <v-icon v-if="isEditing">mdi-close</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
          </v-btn>
        </v-row>
        <v-row v-for="(claimFieldRow, i) in this.claimFieldsByRow" :key="i">
          <template v-for="(claimField, j) in claimFieldRow">
            <v-col cols="12" v-if="claimField.newCategory" :key="j + '-category'">
              <v-subheader>
                <h3>{{ claimField.category }}</h3>
              </v-subheader>
              <v-divider></v-divider>
            </v-col>
            <v-col :cols="claimField.cols" :key="j">
              <ClaimField
                v-if="claimField"
                :publicField="true"
                dense
                :label="claimField.name"
                :hint="claimField.description"
                :promotion="promotion"
                :claimField="claimField"
                v-model="claimFieldValues[claimField.id]"
                :readonly="!isEditing || claim.closed"
                :disabled="disabled"
              >
              </ClaimField>
            </v-col>
          </template>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-subheader>
              <h3>Opt-In</h3>
            </v-subheader>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" md="4">
            <v-checkbox
              v-model="participantOptInValue"
              label="Participant Opt-In"
              :disabled="!isEditing || claim.closed"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="4" v-if="showMarketingCommunicationsOptIn">
            <v-checkbox
              v-model="claimFieldValues[marketingCommunicationsOptInClaimFieldId]"
              label="Marketing Communications Opt-In"
              :disabled="!isEditing || claim.closed"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="4" v-if="showExtendedWarrantyOptIn">
            <v-checkbox
              v-model="claimFieldValues[extendedWarrantyOptInClaimFieldId]"
              label="Extended Warranty Opt-In"
              :disabled="!isEditing || claim.closed"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="this.zeroSales">
        <v-row>
          <v-col cols="6">
            <b>Month: </b>
          </v-col>
          <v-col cols="6"> {{ zeroSalesDate }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <b>Sales: </b>
          </v-col>
          <v-col cols="6"> $0</v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import ClaimField from "../../../gapp-components/components/fields/ClaimField.vue";
export default {
  components: { ClaimField },
  name: "ClaimFormTab",
  data: () => ({
    loading: false,
    claimFields: [],
    claimFieldsByRow: [],
    zeroSales: false,
    zeroSalesDate: null,
    promotion: null,
    participant: null,
    participantOptInValue: false,
    showMarketingCommunicationsOptIn: false,
    marketingCommunicationsOptInClaimFieldId: null,
    showExtendedWarrantyOptIn: false,
    extendedWarrantyOptInClaimFieldId: null,
    claimFieldValues: [],
    isEditing: false,
    isFormValid: false
  }),
  props: {
    claim: Object,
    claimTypeId: Number,
    disabled: Boolean
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        this.claimFields = [];
        this.claimFieldsByRow = [];
        this.claimFieldValues = [];
        this.participant = null;
        this.participantOptInValue = false;
        this.showMarketingCommunicationsOptIn = false;
        this.marketingCommunicationsOptInClaimFieldId = null;
        this.showExtendedWarrantyOptIn = false;
        this.extendedWarrantyOptInClaimFieldId = null;

        let claimFields = await this.$api.get(
          "/api/claimFields/byClaimTypeId/" + this.claimTypeId + "?sort=rankOrder,ASC"
        );
        this.claimFields = claimFields.data.content.filter(claimField => {
          if (claimField.name === "Marketing Communications Opt-In") {
            this.showMarketingCommunicationsOptIn = true;
            this.marketingCommunicationsOptInClaimFieldId = claimField.id;
            return false;
          }
          if (claimField.name === "Extended Warranty Opt-In" || claimField.name === "Extended Marketing Opt-In") {
            this.showExtendedWarrantyOptIn = true;
            this.extendedWarrantyOptInClaimFieldId = claimField.id;
            return false;
          }
          return true;
        });
        this.claimFieldsByRow = [];
        let rowCount = -1;
        let colCount = 0;
        this.claimFields.forEach((claimField, i) => {
          if (!claimField.cols || claimField.cols < 1 || claimField.cols > 12) {
            claimField.cols = 12;
          }
          if (i == 0 || this.claimFields[i].category != this.claimFields[i - 1].category) {
            claimField.newCategory = true;
          } else {
            claimField.newCategory = false;
          }
          if (claimField.newCategory || colCount + claimField.cols > 12) {
            rowCount++;
            colCount = claimField.cols;
          } else {
            colCount += claimField.cols;
          }
          if (!this.claimFieldsByRow[rowCount]) {
            this.claimFieldsByRow[rowCount] = [];
          }
          this.claimFieldsByRow[rowCount].push(claimField);

          if (claimField.defaultValue && claimField.defaultValue.length > 0) {
            this.claimFieldValues[claimField.id] = claimField.defaultValue;
          }
        });

        let promotion = await this.$api.getRelatedObject("promotion", this.claim);
        this.promotion = promotion.data;

        let participant = await this.$api.getRelatedObject("participant", this.claim);
        this.participant = participant.data;
        this.participantOptInValue = this.participant && this.participant.optIn === true;

        let claimFieldValues = await this.$api.get("/api/claimFieldValues/byClaimId/" + this.claim.id);
        claimFieldValues.data.content.forEach(claimFieldValue => {
          if (
            this.showMarketingCommunicationsOptIn &&
            claimFieldValue.claimFieldId === this.marketingCommunicationsOptInClaimFieldId
          ) {
            this.claimFieldValues[claimFieldValue.claimFieldId] =
              claimFieldValue.value === true || claimFieldValue.value === "true";
          } else if (
            this.showExtendedWarrantyOptIn &&
            claimFieldValue.claimFieldId === this.extendedWarrantyOptInClaimFieldId
          ) {
            this.claimFieldValues[claimFieldValue.claimFieldId] =
              claimFieldValue.value === true || claimFieldValue.value === "true";
          } else {
            this.claimFieldValues[claimFieldValue.claimFieldId] = claimFieldValue.value;
          }
        });
        if (this.showMarketingCommunicationsOptIn && this.claimFieldValues[this.marketingCommunicationsOptInClaimFieldId] === undefined) {
          this.claimFieldValues[this.marketingCommunicationsOptInClaimFieldId] = false;
        }
        if (this.showExtendedWarrantyOptIn && this.claimFieldValues[this.extendedWarrantyOptInClaimFieldId] === undefined) {
          this.claimFieldValues[this.extendedWarrantyOptInClaimFieldId] = false;
        }
      } catch (error) {
        console.error("ClaimFormTab fetchData error: " + error);
      } finally {
        this.loading = false;
      }
    },
    onSubmit() {
      this.$emit("onSubmit", {
        claimFieldValues: this.claimFieldValues,
        participantOptInValue: this.participantOptInValue
      });
      this.isEditing = false;
      this.$forceUpdate();
    },
    onEdit() {
      this.isEditing = !this.isEditing;
      if (!this.isEditing) {
        this.fetchData();
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    claimTypeId: {
      immediate: true,
      deep: true,
      handler(v) {
        this.claimTypeId = v;
      }
    },
    claim: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  }
};
</script>
